<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/48X2x0/tc-custom/1.png?1685203880013?1725649954835" alt="This image is the cover for the book Kerry the Unicorn and Her Adventures in Space"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Kerry the Unicorn and Her Adventures in Space
      </h1>
      <p class="bookDescription body article font2">
        <p>In the deep vastness of space, there lived a unicorn with a long sad face. She had lovely pink wings and a long wavy mane, but there was no escaping her unbearable pain. Kerry flew far and wide looking for a friend, someone she could play with until the end.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Longman, Sophie Jacobs
      </h2>
      
      <p class="authorDescription body article">Born in Rochford, Essex, John Longman is an English author dedicated to the written word. With a vivid imagination and a penchant for dabbling in various genres of story-telling, there’s a story for everyone and there’s no way of predicting what he will write next. When not lurking in a darkened room, perched on the edge of his seat, and staring intently at a computer screen, he enjoys working with his hands, soaking up the sunshine and loves to spend as much time on the water as he does in it. Scuba diving – it’s not just a hobby but a way of life.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?31eee334